<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-2 middle-background" 
        :class="{'backgroundgradient noheightforsmall' :(currentRoute == 'selectedloginviewuserprofile' && !userNotFound), 'col-lg-3':(currentRoute != 'selectedloginviewuserprofile' || (userProfileDetails && !userProfileDetails.profileVideoDetails))}"></div>
        <div class="col-md-12 col-lg-6 middle-background  pb-5 main-card" :class="{'backgroundgradient pt-5' :(currentRoute == 'selectedloginviewuserprofile' && !userNotFound)}" v-if="!pageloader">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <br />
              </div>
              <div class=" card card1 ml-3 mr-3 mt-lg-2 jobSec" v-if="userNotFound">
                <div class="d-flex flex-column p-5 mx-auto">
                <img src="../assets/userNotFound.png" class="img-fluid col-10 col-md-8 no-video mt-5 mb-5 mx-auto" alt="novideo">
                <!-- <span class="text-center proximanova-bold black60 mb-5 fontsize24"> User Not Found </span> -->
                </div>
              </div>
              <div class="col-lg-12" v-if="loginuserid != getuserid && !userNotFound && (currentRoute != 'selectedloginviewuserprofile')">
                <div class="row no-gutters mb-2 " @click="previous">                  
                    <img src="../assets/Back.svg" class="img-fluid mr-1 pointer" alt="back" />
                    <!-- <label class="ml-2 fontsize12 my-auto proximanova-bold black prof-details pointer hover">Profile Details</label> -->
                    <div class="d-flex flex-column">
                      <span class="ml-2 fontsize16 my-auto proximanova-bold black prof-details pointer hover">{{firstname}} {{lastname}}</span>  
                      <div v-if="getuseraliasname" class="proximanova ml-1 fontsize12 black">@{{getuseraliasname}}</div>
                    </div>                     
                </div>
              </div>
            </div>
            <div class="col-lg-12"  v-if="!userNotFound">
              <!-- <div class="row no-gutters">
                <br />
              </div> -->
              <div class="shadow card card1 ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                  <div class="row d-flex justify-content-between">
                    <div class="col-lg-2 col-md-2 col-3">
                      <img v-if="!profilePicLink && loginuserid == getuserid" oncontextmenu="return false" alt="profilepic" class="img-fluid" @click="imageModalOpen" src="../assets/AddProfile.svg" />
                      <div v-if="!profilePicLink && loginuserid != getuserid" id="profImage1" class=" text-center mt-0 mt-md-2 pointer rounded-circle white" @click="imageModalOpen" :class="firstname.charAt(0)">
                            <span class="white fontsize17 text-uppercase">{{firstname.charAt(0)}}</span>
                          </div>
                      <div v-else class="profile-pic pointer" @click="imageModalOpen" data-toggle="modal" data-target="#exampleModalprofile">
                        <div class="profile-border">
                          <img :src="profilePicLink"  @load="loadProfilePicture" alt="profilepic" oncontextmenu="return false" class="profileImgSize rounded-circle profileimgad" id="profImage">
                        </div>
                        <img src="../assets/Edit.svg" title="Edit Profile picture" @click="imageModalOpen" v-if="loginuserid == getuserid" alt="profilepic" class="pointer img-fluid img-circle edit">
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-9 col-8 d-flex flex-column nameblock">
                      <div class="mr-md-3 mt-2" v-if="currentRoute == 'selectedloginviewuserprofile' || loginuserid != getuserid">
                        <span class="float-right btn button-create backgroundcolorblack p-1 pl-2 pr-2 borderradius20 white" @click="getInTouch">
                            <span class="proximanova ml-1 fontsize16">Get in Touch <span class="fontsize10">( Coming Soon )</span></span> 
                        </span>
                      </div>
                      <div class="col d-flex justify-content-end mt-2 float-right">
                      <div class=" proximanova-semibold fontsize16 black60  hover d-flex">
                        <span class="mr-2" v-if="this.profileId !== null && this.profileId !== undefined && loginuserid != getuserid"  id="follow">
                          <button @click="followUser" :disabled="disablefollowBtn" v-if="followingTest === 'Follow'" class="border borderradius20 backgroundnone fontsize16 pl-3 pr-3 black60 proximanova-semibold pointer">{{followingTest}}</button>
                          <button @click="UnfollowUser" :disabled="disablefollowBtn" v-if="followingTest === 'UnFollow'" class="border borderradius20 backgroundnone fontsize16 pl-3 pr-3 black60 proximanova-semibold hover">{{followingTest}}</button>
                        </span>
                      <div>
                        <span class="" v-if="this.profileId !== null && this.profileId !== undefined " >
                          <img src="../assets/horizontal_menu_icon.svg" v-popover:fooNA width="20px" id="welcomemore" class="img-fluid float-right mr-2 my-auto menuicon moreactionsmenu" alt="menuicon">
                        </span>
                        <popover name="fooNA" class="welcomemenu">
                          <div class="p-2">
                              <div class="d-flex p-1 justify-content-between">
                                <span class="fontsm black proximanova-semibold">More Actions</span>
                                <div class="closebtnmouseover1">
                                  <img src="../assets/Close1.svg" class="img-fluid closebtn" alt="closebtn" @click="closeMoreActions">
                                </div>
                              </div>
                              <div class="d-flex p-1 action" id="onclickshare" @click="shareprofileLink">
                                  <img src="../assets/Share.svg" alt="share" class="img-fluid pl-1 pr-1 ">
                                  <span class="pt-2 pl-2 d-flex flex-column">
                                    <div class="proximanova fontsize14 black80">Share</div>
                                    <div class="fontsm black60 proximanova">Profile can share with any one</div>
                                  </span>
                              </div>
                              <div class="d-flex p-1 action" id="onclickshare" @click="copyprofileLink">
                                  <img src="../assets/hyperlink1.png" alt="share" class="copylink img-fluid my-auto pl-1 pr-1 ">
                                  <span class="pt-2 pl-2 d-flex flex-column">
                                    <div class="proximanova fontsize14 black80">Copy Profile Link</div>
                                    <div class="fontsm black60 proximanova">Profile can share with any one</div>
                                  </span>
                              </div>
                              <div v-if="loginuserid == getuserid">
                              <div v-if="downloadResumeBtnClicked" class="text-center p-1">
                                <img src="../assets/uploadvideo.svg" alt="uploadvideo" width="27px" class="img-fluid mx-auto mt-1">
                              </div>
                              <div class="d-flex p-1 action" @click="downloadResume" v-else>
                                  <img src="../assets/ConvertResume.svg" alt="downloadresume" class="img-fluid pl-1 pr-1">
                                  <span class="pt-2 pl-2 d-flex flex-column">
                                    <div class="proximanova fontsize14 black80">Download Resume as pdf</div>
                                    <div class="fontsm black60 proximanova">provided information will convert to resume</div>
                                  </span>
                              </div>
                              </div>
                              <div class="d-flex p-1 action" @click="getReportprofile()" v-if="loginuserid != getuserid && currentRoute != 'selectedloginviewuserprofile'">
                                <img src="../assets/Report.svg" class="img-fluid pl-1 pr-1" alt="report">
                                <span class="pt-2 pl-2 d-flex flex-column">
                                  <div class="fontsize14 black80 proximanova">Report Profile</div>
                                  <div class="fontsize12 black60 proximanova">This profile is not relevent and offencive</div>  
                                </span>
                              </div>
                          </div>
                        </popover>
                      </div>
                      </div>
                      </div>
                      <!-- <div v-if="this.profileId== null" class="welcomename fontsize25">
                        <span class="proximanova fontsize32 black30  mr-2">Welcome! to</span>
                        <span class="proximanova-semibold  fontsize32">Worknotion</span>
                        <br />
                        <label class="proximanova fontsize16">Provide your basic information to post</label>
                      </div>
                      <div v-else class="fontsize22 ml-1 d-flex flex-nowrap proximanova-bold black text-capitalize">{{firstname}} {{lastname}}
                        <div v-if="loginuserid == getuserid && !loadingverificationData" class="my-auto">
                          <div class="d-flex pointer" v-if="!userVerificationData.aadharValdid || !userVerificationData.otpSent || !userVerificationData.otpVerified || userVerificationData.verifiedByWnadmin == 'NOT VERIFIED' || userVerificationData.verifiedByWnadmin == 'REJECTED'" @click="displayUserVerificationModal">
                            <img src="../assets/verify_red.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verify your identity" > 
                            <span class="fontsize12 verify proximanova my-auto pointer d-none d-md-block ml-1"> Verify your identity</span>
                          </div>
                          <div class="d-flex pointer"> -->
                            <!-- in progress stage -->
                            <!-- <img src="../assets/verify_orange.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verify your identity" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'REVIEW'"> 
                            <span class="fontsize12 verifycolor1 proximanova my-auto pointer d-none d-md-block ml-1" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'REVIEW'"> Verification Pending</span> -->
                            <!-- done stage -->
                            <!--<img src="../assets/verify_blue.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verify your identity" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'SUCCESS'"> 
                          </div>
                        </div>
                        <div v-else class="my-auto">
                          <div class="d-flex pointer">
                            <img src="../assets/verify_blue.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verify your identity" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'SUCCESS'"> 
                          </div>
                        </div>
                      </div>
                      
                      <div v-if="getuseraliasname && profileId" class="proximanova ml-1 fontsize14 black">@{{getuseraliasname}}</div>
                       <span class="d-none d-md-block">
                      <div class="d-flex flex-wrap pl-1 fontsize16 proximanova">
                        <div v-if="usercompany">{{usercompany}}</div>
                        <div v-if="userdesignation" class="verticaline ml-2 mr-2"> | </div>
                        <div v-if="userdesignation">{{userdesignation}}</div>
                        <div v-if="userdisplayCountry" class="verticaline ml-2 mr-2"> | </div>
                        <div v-if="userdisplayCountry">{{userdisplayCountry}}</div>
                      </div>
                      <div v-if="totalDescription" class="d-flex flex-nowrap ml-1 mt-1 pr-1">
                        <div class="fontsize14 proximanova black60">
                          {{totalDescription}}
                        </div>
                      </div>
                      <div class="d-flex flex-wrap badgesection mt-2" >
                        <span  v-for="(badge, index) in userBadgeList" :key="index">
                          <span class="borderblack60 text-capitalize pl-2 pr-2 pointer lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index < 6">
                            {{badge.badgeList.badgeIn}}
                          </span>
                          <span class="borderblack60 text-capitalize pl-2 pr-2 pointer lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index >= 6 && viewMoreBadges">
                            {{badge.badgeList.badgeIn}}
                          </span>
                          <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index > 5 && index == 6 && !viewMoreBadges" @click="ViewMoreBadgesList">
                            + {{userBadgeList.length - 6}}
                          </span>
                          <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index > 5 && index == (userBadgeList.length-1) && viewMoreBadges" @click="ViewMoreBadgesList">
                            View Less
                          </span>
                        </span>
                        <span v-if="loginuserid == getuserid && this.profileId">
                          <button class="btn border-0 backgroundcolor5 mt-1 p-1 pl-2 pr-3 borderradius20 fontsize12 proximanova-semibold black60" v-if="userBadgeList.length > 0" @click="AddBadgeModal"><img src="../assets/Edit.svg" width="15px" height="15px" alt="edit"> Edit</button>
                          <button class="btn border-0 backgroundcolor5 mt-1 borderradius20 fontsize12 proximanova-semibold black60" v-else @click="AddBadgeModal">+ Add Badge</button> 
                        </span>
                      </div>
                      <div class="d-flex flex-wrap badgesection mt-2">
                        <span class="d-flex flex-wrap" v-for="(link, index1) in userLinksList" :key="index1">
                          <span class="d-none d-md-block pointer p-1">
                            <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                            <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                            </a>
                          </span>
                          <span class="d-block d-md-none pointer p-1" v-if="index1 < 4">
                            <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                              <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                            </a>
                          </span>
                          <span class="d-block d-md-none pointer p-1" v-if="index1 >= 4 && viewMoreLinks">
                            <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                              <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                            </a>
                          </span>
                          <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == 4 && !viewMoreLinks" @click="ViewMoreLinksList">
                            + {{userLinksList.length - 4}}
                          </span>
                          <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == (userLinksList.length-1) && viewMoreLinks" @click="ViewMoreLinksList">
                            View Less
                          </span>
                        </span>
                        <span v-if="loginuserid == getuserid && this.profileId">
                          <img src="../assets/Edit.svg" width="26px" height="26px" class="pointer borderradius20 mt-2 mt-md-1 shadow" alt="edit"  v-if="userLinksList.length > 0" @click="AddLinkModal">
                          <button class="btn border-0 backgroundcolor5 borderradius20 fontsize12 proximanova-semibold black60" v-else @click="AddLinkModal">+ Add Link</button>
                        </span>
                      </div>
                      </span> -->
                    </div>
                  </div>
                  <span class="">
                    <div v-if="this.profileId== null" class="welcomename fontsize25">
                        <span class="proximanova fontsize32 black30  mr-2">Welcome! to</span>
                        <span class="proximanova-semibold  fontsize32">Worknotion</span>
                        <br />
                        <label class="proximanova fontsize16">Provide your basic information to post</label>
                      </div>
                      <div v-else class="fontsize22 ml-1 d-flex flex-nowrap proximanova-bold black text-capitalize">{{firstname}} {{lastname}}
                        <div v-if="loginuserid == getuserid && !loadingverificationData" class="my-auto">
                          <div class="d-flex pointer borderblack60 borderradius20 ml-2 pl-2 pr-2" v-if="!userVerificationData.aadharValdid || !userVerificationData.otpSent || !userVerificationData.otpVerified || userVerificationData.verifiedByWnadmin == 'NOT VERIFIED' || userVerificationData.verifiedByWnadmin == 'REJECTED'" @click="displayUserVerificationModal">
                            <img src="../assets/verify_red.svg" class="my-auto" alt="verify" width="18px" title="Verify your identity" > 
                            <span class="fontsize12 verify proximanova mt-1 pointer d-block d-md-none ml-1"> Verify</span>
                            <span class="fontsize12 verify proximanova mt-1 pointer d-none d-md-block ml-1"> Get Verified</span>
                          </div>
                          <div class="d-flex pointer">
                            <!-- in progress stage -->
                            <img src="../assets/verify_orange.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verify your identity" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'REVIEW'"> 
                            <span class="fontsize12 verifycolor1 proximanova my-auto pointer d-none d-md-block ml-1" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'REVIEW'"> Verification Pending</span>
                            <!-- done stage -->
                            <img src="../assets/verify_blue.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verified" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'SUCCESS'"> 
                          </div>
                        </div>
                        <div v-else class="my-auto">
                          <div class="d-flex pointer">
                            <img src="../assets/verify_blue.svg" class="my-auto ml-2" alt="verify" width="20px" title="Verified" v-if="userVerificationData.aadharValdid && userVerificationData.otpSent && userVerificationData.otpVerified && userVerificationData.verifiedByWnadmin == 'SUCCESS'"> 
                          </div>
                        </div>
                      </div>
                      
                      <div v-if="getuseraliasname && profileId" class="proximanova ml-1 fontsize14 black">@{{getuseraliasname}}</div>
                    <div class="d-flex flex-wrap pl-1 mt-2 fontsize16 proximanova">
                      <div v-if="usercompany">{{usercompany}}</div>
                      <div v-if="userdesignation" class="verticaline ml-2 mr-2"> | </div>
                      <div v-if="userdesignation">{{userdesignation}}</div>
                      <div v-if="userdisplayCountry" class="verticaline ml-2 mr-2"> | </div>
                      <div v-if="userdisplayCountry">{{userdisplayCountry}}</div>
                    </div>
                    <div v-if="totalDescription" class="d-flex flex-nowrap ml-1 mt-1 pr-1">
                      <div class="fontsize14 proximanova black60">{{totalDescription}}</div>
                    </div>
                    <div class="d-flex flex-wrap badgesection mt-2" >
                      <span  v-for="(badge, index) in userBadgeList" :key="index">
                        <span :class="'colour'+badge.badgeList.badgeIn.charAt(0) + ' border'+badge.badgeList.badgeIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova" v-if="index < 6">
                          {{badge.badgeList.badgeIn}}
                        </span>
                        <span :class="'colour'+badge.badgeList.badgeIn.charAt(0) + ' border'+badge.badgeList.badgeIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova" v-if="index >= 6 && viewMoreBadges">
                          {{badge.badgeList.badgeIn}}
                        </span>
                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova-semibold" v-if="index > 5 && index == 6 && !viewMoreBadges" @click="ViewMoreBadgesList">
                          + {{userBadgeList.length - 6}}
                        </span>
                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova-semibold" v-if="index > 5 && index == (userBadgeList.length-1) && viewMoreBadges" @click="ViewMoreBadgesList">
                          View Less
                        </span>
                      </span>
                      <span v-if="loginuserid == getuserid">
                        <button class="btn border-0 backgroundcolor5 mt-1 p-1 pl-2 pr-3 borderradius20 fontsize12 proximanova-semibold black60" v-if="userBadgeList.length > 0" @click="AddBadgeModal"><img src="../assets/Edit.svg" width="15px" height="15px" alt="edit"> Edit</button>
                        <button class="btn border-0 backgroundcolor5 mt-1 borderradius20 fontsize14 proximanova-semibold black60" v-else @click="AddBadgeModal">+ Add Badge</button> 
                      </span>
                    </div>
                    <div class="d-flex flex-wrap badgesection mt-2">
                      <span class="d-flex flex-wrap" v-for="(link, index1) in userLinksList" :key="index1">
                        <span class="d-none d-md-block pointer pt-1 pb-1 pr-1">
                          <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                            <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                          </a>
                        </span>
                        <span class="d-block d-md-none pointer pt-1 pb-1 pr-1" v-if="index1 < 4">
                          <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                            <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                          </a>
                        </span>
                        <span class="d-block d-md-none pointer pt-1 pb-1 pr-1" v-if="index1 >= 4 && viewMoreLinks">
                          <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                            <img :src="require('../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                          </a>
                        </span>
                        <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == 4 && !viewMoreLinks" @click="ViewMoreLinksList">
                          + {{userLinksList.length - 4}}
                        </span>
                        <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == (userLinksList.length-1) && viewMoreLinks" @click="ViewMoreLinksList">
                          View Less
                        </span>
                      </span>
                      <span v-if="loginuserid == getuserid">
                        <img src="../assets/Edit.svg" width="26px" height="26px" class="pointer borderradius20 mt-2 mt-md-1 ml-1 shadow" alt="edit"  v-if="userLinksList.length > 0" @click="AddLinkModal">
                        <button class="btn border-0 backgroundcolor5 borderradius20 fontsize12 proximanova-semibold black60" v-else @click="AddLinkModal">+ Add Link</button>
                      </span>
                    </div>
                  </span>
                  <div class="row no-gutters mb-1">
                    <div class="mt-2 ml-2">
                      <div class="row no-gutters">
                        <div class="col-3 d-flex">
                          <!-- <label class="mr-5 proximanova-semibold fontsize14 black60">Posts</label> -->
                          <label v-if="postsCount > 0" class="proximanova-semibold fontsize14 black60 follower mb-0" id="follower" @click="toggleActiveClass('my_videos')">{{postsCount}}</label>
                          <label v-else class="proximanova-semibold fontsize14 black60 mb-0">00</label>
                          <label class="mr-5 proximanova-semibold fontsize14 black60 ml-2 mb-0">Posts</label>
                        </div>
                        <div class="col-3 d-flex">
                          <!-- <label class="mr-5 proximanova-semibold fontsize14 black60">Followers</label> -->
                          <label v-if="followersCount > 0"  class="proximanova-semibold fontsize14 black60 follower mb-0" id="follower" @click="routetosuggestedpage('followers')">{{followersCount}}</label>
                          <label v-else class="proximanova-semibold fontsize14 black60 mb-0">00</label>
                          <label class="mr-5 proximanova-semibold fontsize14 black60 ml-2 mb-0">Followers</label>
                        </div>
                        <div class="col-3 d-flex ml-4">
                          <!-- <label class="proximanova-semibold fontsize14 black60">Following</label> -->
                          <label v-if="followingCount > 0" class="proximanova-semibold fontsize14 black60 follower mb-0" id="follower" @click="routetosuggestedpage('following')">{{followingCount}}</label>
                          <label v-else class="proximanova-semibold fontsize14 black60 mb-0">00</label>
                          <label class="proximanova-semibold fontsize14 black60 ml-2 mb-0">Following</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="proximanova-semibold black fontsize14 ml-1" v-if="loginuserid == getuserid || userServiceList.length>0">Services I'm available for</span>
                  <div class="d-flex flex-wrap badgesection mt-1 mb-1" >
                      <span  v-for="(service, index) in userServiceList" :key="index">
                        <span :class="'colour'+service.serviceList.serviceIn.charAt(0) + ' border'+service.serviceList.serviceIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova" v-if="index < 6">
                          {{service.serviceList.serviceIn}}
                        </span>
                        <span :class="'colour'+service.serviceList.serviceIn.charAt(0) + ' border'+service.serviceList.serviceIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova" v-if="index >= 6 && viewMoreServices">
                          {{service.serviceList.serviceIn}}
                        </span>
                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova-semibold" v-if="index > 5 && index == 6 && !viewMoreServices" @click="ViewMoreServicesList">
                          + {{userServiceList.length - 6}}
                        </span>
                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova-semibold" v-if="index > 5 && index == (userServiceList.length-1) && viewMoreServices" @click="ViewMoreServicesList">
                          View Less
                        </span>
                      </span>
                      <span v-if="loginuserid == getuserid">
                        <button class="btn border-0 backgroundcolor5 mt-1 p-1 pl-2 pr-3 borderradius20 fontsize12 proximanova-semibold black60" v-if="userServiceList.length > 0" @click="AddServiceModal"><img src="../assets/Edit.svg" width="15px" height="15px" alt="edit"> Edit</button>
                        <button class="btn border-0 backgroundcolor5 mt-1 borderradius20 fontsize12 proximanova-semibold black60" v-else @click="AddServiceModal">+ Add Service</button> 
                      </span>
                    </div>
                    <span class="proximanova-semibold black fontsize14 ml-1" v-if="openToWorkList.length>0">I'm open to work as</span>
                  <div class="d-flex flex-wrap badgesection mt-1 mb-3" >
                      <span  v-for="(open, index) in openToWorkList" :key="index">
                        <span :class="'colour'+open.indexDetailName.charAt(0) + ' border'+open.indexDetailName.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova">
                          {{open.indexDetailName}}
                        </span>
                      </span>
                    </div>
                  <div class="line" v-if="jobchange == 'Y' && loginuserid != getuserid && currentRoute != 'selectedloginviewuserprofile'"></div>
                  <div class="row" v-if="jobchange == 'Y' && loginuserid != getuserid && currentRoute != 'selectedloginviewuserprofile'">
                    <div class="col d-flex justify-content-center">
                      <div class="fontsize16 black60 proximanova mt-3 ml-1 mr-1 ">
                        I am actively looking for job change                        
                      </div>
                      <a class="border-color fontsize14 black80 proximanova-bold mt-3 p-1 pl-2 pr-2 backgroundcolor5 borderradius5">Hire me</a>
                    </div>
                  </div>
                  <div class="line" v-if="loginuserid == getuserid"></div>
                  <div class="row no-gutters" v-if="loginuserid == getuserid">
                    <div class="col d-flex percentageblock">
                      <div class="fontsize40 light-red proximanova-light percentage ml-1 mr-2 mr-lg-4">
                        {{profilePercentage}}
                        <span class="fontsize30 light-red proximanova-light sub mt-3 ml-1">%</span>
                      </div>

                      <div class="ml-3 mt-2 profilestrength">
                        <div class="mr-2 proximanova fontsize12 black60 ">Profile strength:</div>

                        <div class="mr-2">
                          <label class="fontsize14 proximanova-semibold black pointer" v-popover:foo>{{profileStrengthLabel}}</label>
                          <img src="../assets/Dropdown.svg" alt="dropdown" v-popover:foo class="img-fluid p-2 pointer" />

                          <popover name="foo" class="profileStrengthpop">
                            <p class="proximanova-semibold fontsize14 black">Profile Strength</p>
                            <span class="proximanova-semibold fontsize12 black30 ">Video Profile</span>
                            <div class="line mr-3 mb-2 mt-1"></div>
                            <div class="d-flex">
                              <span class="mr-auto proximanova black80 fontsize12">Video Resume</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span
                                v-if="this.resumeVideoId== null"
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Not Started</span>
                              <span
                                v-else
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Video Profile</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span
                                v-if="this.profileVideoId == null"
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Not Started</span>
                              <span
                                v-else
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <span class="proximanova-semibold fontsize12 black30 ">Profile Details</span>
                            <div class="line mr-3 mt-1 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Basic Information</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span
                                v-if="this.profileId== null"
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Not Started</span>
                              <span
                                v-else
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                              >Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Profile picture</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span v-if="!profilePicLink" class="proximanova-semibold fontsize12 black30  justify-content-end mr-3">Not Started</span>
                              <span v-else class="proximanova-semibold fontsize12 black30  justify-content-end mr-3">Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Contact Details</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                                v-if="this.primaryphoneno !== null && this.primaryphoneno !== undefined"
                              >Completed</span>
                              <span
                                class="proximanova-semibold fontsize12 black30  justify-content-end mr-3"
                                v-else
                              >Not Started</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Work Experience</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="workExperience.length < 1">Not Started</span>
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="workExperience.length > 0">Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Education / Certifications</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="educationList.length < 1">Not Started</span>
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="educationList.length > 0">Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex">
                              <span class="proximanova black80 fontsize12 mr-auto">Location</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="userZipcode == '' && !userCountry && !userState && !userCity">Not Started</span>
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-else>Completed</span>
                            </div>
                            <div class="line-opacity-4 mr-3 mt-2 mb-2"></div>
                            <div class="d-flex mb-2">
                              <span class="proximanova black80 fontsize12 mr-auto">Skills</span>
                              <img src="../assets/NotStarted.svg" alt="notstarted" class="img-fluid mr-1" />
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-if="userKnowledgeList.length > 0 || userTechnologyList.length > 0">Completed</span>
                              <span class="proximanova-semibold fontsize12 black30  justify-content-end mr-3" v-else>Not Started</span>
                            </div>
                          </popover>
                        </div>
                      </div>
                    </div>
                    <div class="justify-content-end mt-3 mr-lg-1">
                      <div v-if="this.profileId!= null " class="navtoPage" @click="changeeditprofileImage">
                          <img :src="editprofileimage" alt="edit" id="edit1" class="img-fluid mr-1" />
                          <label class="mr-3 fontsize12 proximanova-bold black menuicon" id="edittext">Edit Profile</label>
                      </div>
                      <div v-else class="navtoPage"  @click="changecreateprofileImage">
                          <img :src="createprofileimage" alt="edit" class="img-fluid mr-1" />
                          <label class="mr-3 fontsize12 proximanova-bold black menuicon" id="createtext">Create Profile</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <nav class="nav ml-3 mr-3">
                <div class="col-12 card-header mt-3 mt-lg-4 mb-3">
                  <div class="row no-gutters">
                    <ul class="nav nav-tabs proximanova-bold blue fontsize12">
                      <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction" v-if="loginuserid == getuserid">
                        <a
                          class="proximanova-semibold blck60"
                          :class="{'proximanova-semibold blue border-tab':activeClass == 'video_profile'}"
                          id="video_profile"
                          @click="toggleActiveClass('video_profile')"
                        >Video Profile</a>
                      </li>
                      <li class="nav-item mr-lg-3 mr-md-3 mouseoveraction">
                        <a
                          class="proximanova-semibold blck60"
                          :class="{'proximanova-semibold blue border-tab':activeClass == 'profile_details'}"
                          id="profile_details"
                          @click="toggleActiveClass('profile_details')"
                        >
                        <span v-if="loginuserid == getuserid">Profile Details</span> 
                        <span v-else>Overview</span> 
                        </a>
                      </li>
                      <li class="nav-item mouseoveraction">
                        <a
                          class="proximanova-semibold blck60"
                          :class="{'proximanova-semibold  blue border-tab':activeClass == 'my_videos'}"
                          id="my_videos"
                          @click="toggleActiveClass('my_videos')"
                        >My Videos</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
              <div v-show="showprofiledetails">
                <selecteduserprofilevideo :class="{'d-block d-lg-none' : (loginuserid != getuserid)}" :userProfileDetails="userProfileDetails" v-if="(loginuserid != getuserid) && userProfileDetails && userProfileDetails.profileVideoDetails"></selecteduserprofilevideo>
                <profiledetailstab :userProfileDetails="userProfileDetails" v-if="showprofiledetails"></profiledetailstab>
              </div>
              <div v-show="showvideoprofile">
                <videoprofiletab :userProfileDetails="userProfileDetails" v-if="showvideoprofile && (loginuserid == getuserid)"></videoprofiletab>
                <!-- <selecteduserprofilevideo :userProfileDetails="userProfileDetails" v-if="showvideoprofile && (loginuserid != getuserid)"></selecteduserprofilevideo> -->
              </div>
              <div v-show="showvidoes">
                <div class="row no-gutters" v-if="!profileId">
                  <div class="col-lg-12 pb-3">
                    <div class="row no-gutters">
                    <br />
                    </div>
                    <div class="ml-3 mr-3 mt-lg-2">
                      <no-profile-id-component></no-profile-id-component>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters ml-3 mr-3" v-else>
                  <div class="col-12 mb-3">
                    <div v-if="loginuserid == getuserid" class="col-12 myvideosection d-flex justify-content-lg-start justify-content-md-start justify-content-sm-start p-2 pb-3">
                      <span
                        class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                        :class="{'activeVideoSub':activeVideoClass == 'posts_tab'}"
                        id="posts_tab"
                        @click="changePillBtnColour('posts_tab')">Posts</span>
                      <span
                        class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                        :class="{'activeVideoSub':activeVideoClass == 'saved_tab'}"
                        id="saved_tab"
                        @click="changePillBtnColour('saved_tab')">Saved</span>
                      <span
                        class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                        :class="{'activeVideoSub':activeVideoClass == 'liked_tab'}"
                        id="liked_tab"
                        @click="changePillBtnColour('liked_tab')">Liked</span>
                      <span
                        class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                        :class="{'activeVideoSub':activeVideoClass == 'shared_tab'}"
                        id="shared_tab"
                        @click="changePillBtnColour('shared_tab')">Shared</span>
                      <span
                        class="fontsize14 black80 proximanova pillbtn mr-2 mr-lg-3 p-1"
                        :class="{'activeVideoSub':activeVideoClass == 'draft_tab'}"
                        id="draft_tab"
                        @click="changePillBtnColour('draft_tab')">Draft</span>
                    </div>
                    <!-- POSTED VIDEOS TAB -->
                    <div v-if="postedVideosTab">
                      <posted-videos :userProfileDetails="userProfileDetails"></posted-videos>
                    </div>
                    <!-- SAVED VIDEOS TAB -->
                    <div v-if="savedVideosTab">
                      <saved-videos></saved-videos>
                    </div>
                    <!-- LIKED VIDEOS TAB -->
                    <div v-if="likedVideosTab">
                      <liked-videos></liked-videos>
                    </div>
                    <!-- SHARED VIDEOS TAB -->
                     <div v-if="sharedVideosTab">
                       <shared-videos></shared-videos>
                    </div>
                    <!-- DRAFT VIDEOS TAB -->
                    <div v-if="DraftvideosTab">
                      <draft-videos :userProfileDetails="userProfileDetails"></draft-videos>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <verify-user-modal v-if="openUserVerificationModal" :userProfileDetails="userProfileDetails" @closeUserVerificationmodal= "closeUserVerificationmodal"></verify-user-modal>
        <add-badge-modal  v-if="openAddBadgeModal" :userBadgeList="userBadgeList" @closebadgemodal="closebadgemodal"></add-badge-modal>
        <add-service-modal v-if="openAddServiceModal" :userServiceList="userServiceList" @closeservicemodal="closeservicemodal"></add-service-modal>
        <add-link-modal   v-if="openAddLinkModal" :userLinksList="userLinksList" @closebadgemodal="closeLinkModal"></add-link-modal>
        <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
        <upload-profile-picture-modal v-if="showProfilePictureModal" :profilePictureObj="profilePictureObj" @closeProfilePhotoModal="closeProfilePhotoModal"></upload-profile-picture-modal>
        <reportProfileModal  v-if="reportprofilemodal" :reportuser="reportprofileobject" @closereport = "closereportprofileModal"></reportProfileModal>
        <div class="col middle-background" :class="{'backgroundgradient' :(currentRoute == 'selectedloginviewuserprofile' && !userNotFound)}">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
          <selecteduserprofilevideoright class="mt-5 fixed" :class="{'d-none d-lg-block' : (loginuserid != getuserid), 'pt-4':currentRoute == 'selectedloginviewuserprofile'}" :userProfileDetails="userProfileDetails" v-if="(loginuserid != getuserid) && userProfileDetails && userProfileDetails.profileVideoDetails"></selecteduserprofilevideoright>
          <pendingActivities v-if="currentRoute != 'selectedloginviewuserprofile' && loginuserid == getuserid || (loginuserid != getuserid && currentRoute != 'selectedloginviewuserprofile' && !userProfileDetails.profileVideoDetails)"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pendingActivities from "../components/PendingActivities.vue";
import vselect from "@/css/vselect.css";
import httpuserprofile from "@/js/http-userprofile.js";
import { bus } from "../main";
import Vue from "vue";
import Popover from "vue-js-popover";
import moment from 'vue-moment'
import $ from "jquery";
import router from '../router'
import postedVideos from '../components/VideoTabs/PostedVideos.vue'
import savedVideos from '../components/VideoTabs/SavedVideos.vue'
import likedVideos from '../components/VideoTabs/LikedVideos.vue'
import sharedVideos from '../components/VideoTabs/SharedVideos.vue'
import draftVideos from '../components/VideoTabs/DraftVideos.vue'
import uploadProfilePictureModal from '../components/UploadProfilePicture.vue'
import NoProfileIdComponent from '../components/NoProfileId.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import NoProfileIdModalComponent from '../components/NoprofileIdModal.vue'
import videoprofiletab from './userprofile/VideoProfile.vue'
import selecteduserprofilevideo from './userprofile/SelecteduserVideoProfile.vue'
import selecteduserprofilevideoright from './userprofile/SelecteduserVideoProfileRight.vue'
import profiledetailstab from './userprofile/ProfileDetails.vue'
import reportProfileModal from '../components/reportUserModal.vue'
import verifyUserModal from '../components/VerifyUserAccount.vue'
import AddBadgeModal from '../components/AddBadgeModal.vue'
import AddServiceModal from '../components/AddServiceModal.vue'
import AddLinkModal from '../components/AddUserLinksModal.vue'
import sessionUtils from '@/js/session-util.js'
import commonUtils from '@/js/common-utils.js'
Vue.use(Popover);

export default {
  components: {
    videoprofiletab,
    selecteduserprofilevideo,
    selecteduserprofilevideoright,
    profiledetailstab,
    pendingActivities,
    postedVideos,
    savedVideos,
    likedVideos,
    sharedVideos,
    draftVideos,
    uploadProfilePictureModal,
    NoProfileIdComponent,
    NoProfileIdModalComponent,
    APIerrorModal,
    reportProfileModal,
    AddBadgeModal,
    AddServiceModal,
    AddLinkModal,
    verifyUserModal
  },

  data() {
    return {
      userNotFound : false,
      currentRoute : null,
      documentTitle : 'Worknotion | Collaboration Network and Job search',
      createprofileimage : require('../assets/CreateProfile.svg'),
      editprofileimage : require('../assets/EditProfile.svg'),
      pageloader : true,
      //login user id
      loginuserid : sessionUtils.getUserId(),
      // loginuserid : 5,
      loginuserprofileid : sessionUtils.getUserProfileId(),
      // user id
      getuserid: null,
      getuseraliasname : '',
      email: "",
      profileId: null,
      userProfileDetails : {},
      showprofiledetails: false,
      showvideoprofile: true,
      showvidoes: false,
      downloadResumeBtnClicked : false,
      firstname: "",
      lastname: "",
      aboutYou : '',
      totalDescription : '',
      usercompany: "",
      userdesignation : '',
      userdisplayCountry : '',
      city: "",
      profilePercentage : 0,
      displayNoProfileModalComponent : false,
      profileresumemodalopen : false,
      profileresumeobj : {},
      profileStrengthLabel : 'Very Low',
      primaryphoneno: "",
      alternatePhoneNumber : '',
      workExperience: [],
      educationList : [],
      userState : {},
      userCity : {},
      userCountry : {},
      userZipcode : '',
      userWorkAuthorization : '',
      userKnowledgeList : [],
      userTechnologyList : [],
      profileVideoId : null,
      profileVideoDetails : null,
      resumeVideoId : null,
      resumeVideoDetails : null,
      employmentTypeList : [],
      typeOfDegreeList : [],
      //profile picture
      profilePicLink:'',
      showProfilePictureModal : false,
      displayAPIerrorModal : false,
      profilePictureObj : {},
      profileImage : [],
      jobchange: 'N',
      activeClass: "video_profile",
      //badge section
      openAddBadgeModal : false,
      userBadgeList : [],
      viewMoreBadges : false,
      //service section
      openAddServiceModal : false,
      userServiceList : [],
      viewMoreServices : false,
      //link section
      openAddLinkModal : false,
      userLinksList : [],
      viewMoreLinks : false,
      // open to work section
      openToWorkList : [],
      //my videos section
      activeVideoClass : 'posts_tab',
      postedVideosTab : false,
      savedVideosTab : false,
      likedVideosTab : false,
      sharedVideosTab : false,
      DraftvideosTab : false,
      followersCount: null,
      followingCount: null,
      postsCount : null,
      //selected user
      reportprofilemodal : false,
      reportprofileobject : {},
      currentUserEmail : sessionUtils.getUserEmail(),
      followingTest: 'Follow',
      disablefollowBtn : false,
      //user verifications
      openUserVerificationModal : false,
      userVerificationData : {},
      loadingverificationData : true,
    };
  },
  watch: {
  '$route.params.id': function (id) {     
      this.getuseraliasname = id;
      this.pageloader = true;
      this.resetData()
      this.fetchdata();   
    }
  },
  methods: {
    resetData() {
      this.totalDescription = false;
      this.workExperience = [];
      this.educationList = [];
      this.userBadgeList = [];
      this.userLinksList = [];
      this.openToWorkList = [];
      this.userServiceList = [];
      this.viewMoreServices = false;
      this.viewMoreBadges = false;
      this.viewMoreLinks = false;
      this.followersCount = null;
      this.followingCount = null;
      this.postsCount = null;
      this.activeClass = 'video_profile';
      this.showvideoprofile = true;
      this.showprofiledetails = false;
      this.showvidoes = false;
      this.documentTitle = 'Worknotion | Collaboration Network and Job search'
      this.updateMetaInfo()
    },
    setDocumentTitle() {
      let docsTtile = '';
      let currentCity = '';
      let currentState = '';
      let currentCountry = '';
      if(this.workExperience.length > 0){
        for(var i =0; i < this.workExperience.length; i++){
          if(this.workExperience[i].currentWorkingFlag == 'Y'){
            if(this.workExperience[i].city){
              currentCity = this.workExperience[i].city.cityName
            }
            if(this.workExperience[i].state){
              currentState = this.workExperience[i].state.stateName
            }
            if(this.workExperience[i].country){
              currentCountry = this.workExperience[i].country.countryName
            }
          }
        }
      }
      if(this.workExperience.length < 1 && this.educationList.length > 0){
        for(var j =0; j < this.educationList.length; j++) {
          if(this.educationList[j].currentStudyFlag == 'Y'){
            if(this.educationList[j].city){
              currentCity = this.educationList[j].city.cityName
            }
            if(this.educationList[j].state){
              currentState = this.educationList[j].state.stateName
            }
            if(this.educationList[j].country){
              currentCountry = this.educationList[j].country.countryName
            }
          }
        }
      }
      if(currentCity && currentState){
        docsTtile = this.firstname+' '+this.lastname+' | '+this.usercompany+', '+currentCity +', '+ currentCountry +' | Worknotion'
      }else{
        docsTtile = this.firstname+' '+this.lastname+' | '+this.usercompany+' | Worknotion'
      }
      // capitalize //
      const arr = docsTtile.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      const str2 = arr.join(" ");
      //// end ////
      this.documentTitle =str2
      console.log("document title : ", this.documentTitle)
      this.updateMetaInfo()
    },
    updateMetaInfo() {
      document.title = this.documentTitle
    },
    previous(){
      this.$router.go(-1);
    },
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    ///////////////////// if login user ////////////////////////////////////////
    loadProfilePicture() {
      document.getElementById('profImage').classList.remove('profileimgad')
    },
    //this will invoke after click on close button on more actions menu
    closeMoreActions : function(){
      document.getElementById('welcomemore').click()
    },
    //navigate user to suggested people after click on followres/following count
    routetosuggestedpage:function(element){
      if(this.currentRoute != 'selectedloginviewuserprofile'){
      if(this.profileId !== null & this.profileId !== undefined && this.loginuserid == this.getuserid) {
        sessionUtils.setSelectedElement('people')
        // sessionStorage.setItem('activeElement', elementname)
        sessionUtils.setPeopleActiveTab(element)
        router.push({
          name : 'People'
        })
      }else if(this.profileId !== null & this.profileId !== undefined && this.loginuserid != this.getuserid && this.userProfileDetails && this.userProfileDetails.privacy != 'PRIVATE'){
        sessionUtils.setSelectedElement('people')
        sessionUtils.setPeopleActiveTab(element)
        this.$router.push({name: 'selectedUserPeople', params: { id: this.getuseraliasname , peopleType : element}});
      }
      }else{
        this.navToSignInWithSelectedUser()
      }
    },
    //download resume
    downloadResume  : function() {
      console.log(this.profileId)
      this.downloadResumeBtnClicked = true;
      httpuserprofile.get('/userprofile/generatePdf/'+this.profileId+'/1')
      .then((response) => {
        console.log(response)
        this.downloadResumeBtnClicked = false;
        let fileURL = response.data.url;
        let fileLink = document.createElement('a');
        //console.log(fileURL);
        //fileLink.href = 'http://www.africau.edu/images/default/sample.pdf';
        fileLink.href = fileURL;
        fileLink.target = '_blank';
        fileLink.download = response.data.fileName;
        //document.body.appendChild(fileLink);
        // console.log(fileLink)
        fileLink.click();
      }).catch((e)=> {
        console.log(e)
        this.downloadResumeBtnClicked = false;
        this.displayAPIerrorModal = true;
      })
    },
    shareprofileLink : function() {
      var vm = this;
      if (!navigator.share) return;

      navigator.share({
            url: "https://worknotion.com/wn/"+this.getuseraliasname,
            title: "Worknotion | Collaboration Network and Job search",
            text: "Worknotion is a video platform that allows professionals and businesses to create and share their stories, profiles, resumes, and Free job postings. Get access to insights!"
        })
        .then(() => { console.log("Shared YEEEE!!!!!"); })
        .catch((error) => { vm.$toast.info("No longer support this functionality in this device/browser") });
    },
    copyprofileLink : function() {
      var vm = this;
      var link = "https://worknotion.com/wn/"+this.getuseraliasname
      // var link = "http://localhost:8080/wn/"+this.getuseraliasname
      navigator.clipboard.writeText(link);
      vm.$toast.success("Copied to clipboard")
    },
    //badges
    AddBadgeModal : function() {
      this.openAddBadgeModal = true;
    },
    closebadgemodal : function() {
      this.openAddBadgeModal = false;
    },
    ViewMoreBadgesList : function() {
      this.viewMoreBadges = !this.viewMoreBadges;
    },
    //services
    AddServiceModal : function() {
      this.openAddServiceModal = true;
    },
    closeservicemodal : function() {
      this.openAddServiceModal = false;
    },
    ViewMoreServicesList : function() {
      this.viewMoreServices = !this.viewMoreServices;
    },
    // links
    AddLinkModal  : function() {
      this.openAddLinkModal = true;
    },
    closeLinkModal : function() {
      this.openAddLinkModal = false;
    },
    ViewMoreLinksList : function() {
      this.viewMoreLinks = !this.viewMoreLinks;
    },
    //navigate user to create profile page
    changecreateprofileImage  :function() {
      var that = this
      this.createprofileimage = require('../assets/CreateProfileCopy.png')
      document.getElementById('createtext').style.color = '#0078FF'
      setTimeout(myFun, 5000)
      function myFun() {
        that.createprofileimage = require('../assets/CreateProfile.svg')
        document.getElementById('createtext').style.color = 'black'
      }
      router.push({
        name : 'createprofile'
      })
    },
    //navigate user to edit profile page
    changeeditprofileImage : function() {
      router.push({
        name : 'editprofile'
      })
    },
    //upload profile image modal methods
    imageModalOpen : function() {
      if(this.profileId){
        if((this.loginuserid == this.getuserid)){
      this.showProfilePictureModal = true;
      this.profilePictureObj.profilepictureLink = this.profilePicLink;
      this.profilePictureObj.userId = this.getuserid;
        }
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    //this will invoke after click on cancel button on profile picture modal/ sucessfully saved the profile picture
    // if sttaus is success update profile picture
    closeProfilePhotoModal : function(statusObj){
      console.log("modal closed", statusObj)
      this.showProfilePictureModal = false;
      if(statusObj.status === 'SUCCESS'){
        this.updateProfilePicture()
      }
    },
    updateProfilePicture(){
      httpuserprofile.get('/userprofile/userbyid/'+this.getuserid)
      .then((response) => {
        this.profilePicLink = response.data.profilePictureLink;
        bus.$emit('updatingProfilePictureLink', this.profilePicLink);
      }).catch((e) => {
        console.log(e)
      })
    },
    // this will invoke after click on pill btns in my videos sections to display selected seaction videos
    changePillBtnColour : function(tabElement) {
      this.activeVideoClass = tabElement
      var that = this;
      if(this.activeVideoClass == 'posts_tab') {
        openPostsTab()
      }else if(this.activeVideoClass == 'saved_tab'){
        openSavedvideosTab()
      }else if(this.activeVideoClass == 'liked_tab'){
        openLikedvideosTab()
      }else if(this.activeVideoClass == 'shared_tab') {
        openSharedvideosTab()
      }else{
        openDraftvideosTab()
      }
      function openPostsTab(){
        that.postedVideosTab = true;
        that.savedVideosTab = false;
        that.likedVideosTab = false;
        that.sharedVideosTab = false;
        that.DraftvideosTab = false;
      }
      function openSavedvideosTab(){
        that.postedVideosTab = false;
        that.savedVideosTab = true;
        that.likedVideosTab = false;
        that.sharedVideosTab = false;
        that.DraftvideosTab = false;
      }
      function openLikedvideosTab() {
        that.postedVideosTab = false;
        that.savedVideosTab = false;
        that.likedVideosTab = true;
        that.sharedVideosTab = false;
        that.DraftvideosTab = false;
      }
      function openSharedvideosTab() {
        that.postedVideosTab = false;
        that.savedVideosTab = false;
        that.likedVideosTab = false;
        that.sharedVideosTab = true;
        that.DraftvideosTab = false;
      }
      function openDraftvideosTab() {
        that.postedVideosTab = false;
        that.savedVideosTab = false;
        that.likedVideosTab = false;
        that.sharedVideosTab = false;
        that.DraftvideosTab = true;
      }
    },
    fetchdata() {
      this.getEmploymentType()
      this.getTypeofDegreeList()
    },
    // display content based on active class
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
      pauseProfileVideosIfPlaying()
      if (elementId == "video_profile") {
        this.videoProfile();
        this.cleartabStates()
      } else if (elementId == "profile_details") {
        this.profileDetails();
        this.cleartabStates()
      } else {
        // if(this.currentRoute != 'selectedloginviewuserprofile'){
        this.myVideos();
        this.postedVideosTab = true;
        if(this.profileId){
          this.changePillBtnColour('posts_tab')
        }
        // }else{
        //   this.navToSignInWithSelectedUser()
        // }
      }
      function pauseProfileVideosIfPlaying() {
        let vid1 = document.getElementById('profileVideo')
        let vid2 = document.getElementById('profileVideo1')
        if(vid1) {
          vid1.pause()
        }
        if(vid2) {
          vid2.pause()
        }
        bus.$emit('stopPlayingselecteduserProfileVideo', false)
    }
    },
    cleartabStates() {
      this.postedVideosTab = false;
      this.savedVideosTab = false;
      this.likedVideosTab = false;
      this.sharedVideosTab = false;
    },
    closeNoProfileIdModal(){
      this.displayNoProfileModalComponent = false;
    },
    displayUserVerificationModal(){
      this.openUserVerificationModal = true;
    },
    //closing verification modal 
    closeUserVerificationmodal(status) {
      if(status == 'SUCCESS'){
        this.getUserProfileVerificationData()
      }
      this.openUserVerificationModal = false;
    },
    getEmploymentType : function() {
      httpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 2 }
        })
        .then(response => {
          this.employmentTypeList = response.data;
          console.log(response.data);
          // this.getUserByID()
          this.getUserByAliasname()
        }).catch((e) => {
          this.pageloader = false;
        });
    },
    getTypeofDegreeList : function(){
      httpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 4 }
        })
        .then(response => {
          this.typeOfDegreeList = response.data;
          console.log(response.data);
        });
    },
    //fetching user profile data
    getUserByAliasname(){
    // getUserByID() {
      this.profilePercentage = 0;
      // httpuserprofile
      //   .get("/userprofile/userbyid/" + this.getuserid)
      httpuserprofile
        .get("/userprofile/getUserByAliasName/" + this.getuseraliasname)
        .then(response => {
          console.log("response check : ", response)
          if(response.data && response.data.errorCode && response.data.errorCode == 1021){
            this.userNotFound = true;
          }else{
            this.userNotFound = false;
          }
          this.pageloader = false;
          this.userProfileDetails = response.data; 
          this.getuserid = response.data.userId;
          this.profileId = response.data.profileId;
          if(this.loginuserid == this.getuserid){
            this.toggleActiveClass('video_profile')
          }else{
            this.toggleActiveClass('profile_details')
          }
          //basic info
          this.firstname = response.data.firstName;
          this.lastname = response.data.lastName;
          this.profilePicLink = response.data.profilePictureLink;
          this.profileImage.push(this.profilePicLink)
          // this.aboutYou = response.data.aboutYou;
          let aboutyou = response.data.aboutYou;
          if(aboutyou) {
            this.totalDescription = aboutyou
          }
          if(response.data.companyDetails){
            this.usercompany = response.data.companyDetails.companyName
          }
          if(response.data.designation){
            this.userdesignation = response.data.designation.roleName
          }
          if(response.data.country){
            this.userdisplayCountry = response.data.country.countryName
          }
          this.jobchange = "N";
          if(response.data.jobChangeStatus){
            this.jobchange = response.data.jobChangeStatus;
          }
          //contact info
          this.email = response.data.email;
          this.primaryphoneno = response.data.primaryPhoneNumber;
          this.alternatePhoneNumber = response.data.alternatePhoneNumber;
          //experience
          if (response.data.workExperience.length > 0) {
            let experienceList = response.data.workExperience
            for(var i =0; i < experienceList.length; i++){
              for(var j = 0; j < this.employmentTypeList.length; j++){
                if(this.employmentTypeList[j].id == experienceList[i].employeementTypeId) {
                  experienceList[i].employeementTypeString = this.employmentTypeList[j].indexDetailName;
                }
              }
              let descript =  experienceList[i].description;
              experienceList[i].description1 = descript.substr(0,196)
              experienceList[i].description2 = descript.substr(196)
              this.workExperience.push(experienceList[i])
            }
            this.userProfileDetails.workExperience = this.workExperience;
          }
          //education
          if(response.data.userEducation.length > 0){
            let education = response.data.userEducation
            for(var k =0; k < education.length; k++){
              for(var l=0; l < this.typeOfDegreeList.length; l++){
                if(this.typeOfDegreeList[l].id == education[k].typeOfDegreeId) {
                  education[k].typeOfDegreeString = this.typeOfDegreeList[l].indexDetailName
                }
              }
              this.educationList.push(education[k])
            }
            this.userProfileDetails.userEducation = this.educationList;
          }
          //location
          this.userCountry = response.data.country;
          this.userState = response.data.state;
          this.userCity = response.data.city;
          this.userZipcode = response.data.zipCode;
          this.userWorkAuthorization = response.data.workAuthorization;
          //skills
          this.userKnowledgeList = response.data.userKnowledge;
          this.userTechnologyList = response.data.userTechnology

          //profile video
          this.profileVideoId = response.data.profileVideoId;
          this.profileVideoDetails = response.data.profileVideoDetails;

          //resume video
          this.resumeVideoId = response.data.resumeVideoId;
          this.resumeVideoDetails = response.data.resumeVideoDetails;

          //profilePercentage
          if(this.profileId !== '' && this.profileId !== undefined){
            this.profilePercentage += 10;
          }
          if(this.profilePicLink !== '' && this.profilePicLink !== null && this.profilePicLink !== undefined){
            this.profilePercentage += 5;
          }
          if(this.primaryphoneno) {
            this.profilePercentage += 10;
            this.$store.state.addedContactInfo = true;
          }
          if(this.workExperience.length > 0){
            this.profilePercentage += 20;
          }
          if(this.educationList.length > 0) {
            this.profilePercentage += 10;
          }
          if(this.userZipcode) {
            this.profilePercentage +=5;
          }
          if(this.userKnowledgeList.length > 0 && this.userTechnologyList.length > 0){
            this.profilePercentage +=10;
          }
          if(response.data.profileVideoId !== null){
            this.profilePercentage +=15;
          }
          if(response.data.resumeVideoId !== null){
            this.profilePercentage +=15
          }
          this.getprofileStrengthLabel()
          this.getCountOfUserFollowersandFolllowing()
          if(this.profileId) {
            this.fetchUserBadgeList()
            this.fetchUserServiceList()
            this.fetchUserLinksList()
            this.fetchOpenToWorkInformation()
            this.getUserProfileVerificationData()
            this.setDocumentTitle()
          }
          if(this.loginuserid != this.getuserid && (this.currentRoute != 'selectedloginviewuserprofile')){
            console.log("view profile api calling")
            this.getFollowFlagValue()
            this.viewUserProfile()
          }
          // if(this.loginuserid == this.getuserid && this.profileId){
          //   this.getUserProfileVerificationData()
          // }
        }).catch((e) => {
          // if(exception.name == 'NetworkError'){
          //   console.log('There was a network error.');
          // }
          this.pageloader = false;
        });
    },
    getprofileStrengthLabel : function() {
      //profileStrengthLabel
      if(10 <= this.profilePercentage && this.profilePercentage <= 40){
        this.profileStrengthLabel = "Very Low"
      }else if(41 <= this.profilePercentage && this.profilePercentage <= 70){
        this.profileStrengthLabel = "Average"
      }else if(71 <= this.profilePercentage && this.profilePercentage <= 90){
        this.profileStrengthLabel = "Strong"
      }else if(91 <= this.profilePercentage && this.profilePercentage <= 100){
        this.profileStrengthLabel = "All Stars"
      }
      this.$store.state.profileStrengthPercentage = this.profilePercentage;
      this.$store.state.profileStrength = this.profileStrengthLabel;
      commonUtils.updateLoginUserWorkExperience(this.workExperience)
    },
    getCountOfUserFollowersandFolllowing() {
      httpuserprofile
        .get("/userprofile/getUserFollowAndFollowingCount?userProfileId="+this.profileId)
        .then(response => {
          console.log("post videos count : ", response)
          this.postsCount = response.data.postedVideoCount;
          this.followingCount = response.data.followingCount;
          this.followersCount = response.data.followerCount;
        }).catch((e) => {
          console.log(e)
        })
    },
    getFollowFlagValue() {
      // if video visibility is follower we are going to get follow relation and add profile video link
      httpuserprofile
        .get("userprofile/getUsertoUserFollowFlag?profileId="+this.profileId+'&followerId='+this.loginuserprofileid)
        .then(response => {
          console.log("fetch follow flag : ", response)
          let followflag = response.data[0].followingFlag;
          this.userProfileDetails.selectedUserFollowFlag = followflag;
          if(followflag == 'Y'){
            this.followingTest = 'UnFollow'
          }else if(followflag == 'N'){
            this.followingTest = 'Follow'
          }
        }).catch((e) => {
          console.log(e)
      })
    },
    fetchUserBadgeList : function() {
      httpuserprofile.get("/userprofile/getUserBadges?profileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userBadgeList = response.data
        }
        console.log("userbadgelist : ", this.userBadgeList)
      }).catch((e) => {
        console.log(e)
      })
    },
    fetchUserServiceList : function() {
      httpuserprofile.get("/userprofile/getUserServices?profileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userServiceList = response.data
        }
        console.log("userservicelist : ", this.userServiceList)
      }).catch((e) => {
        console.log(e)
      })
    },
    fetchUserLinksList : function() {
      httpuserprofile.get("/userprofile/getUserLinksList?userProfileId="+this.profileId)
      .then((response) => {
        console.log("saved user badge list : ", response)
        if(response.data && response.data.length > 0) {
          this.userLinksList = response.data
        }
        console.log("userbadgelist : ", this.userLinksList)
      }).catch((e) => {
        console.log(e)
      })
    },
    fetchOpenToWorkInformation : function() {
      httpuserprofile.get("/userprofile/getJobChangeTypeByProfileId?profileId="+this.profileId)
      .then((response) => {
        console.log("saved open to work list : ", response)
        if(response.data && response.data.length > 0) {
          this.openToWorkList = response.data
        }else{
          this.openToWorkList = [];
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    viewUserProfile : function() {
      var vfd = new FormData()
      let obj = { 
        profileId: this.loginuserprofileid,
        userViewedProfileId: this.profileId
      }
      console.log("view profile obj in welcome page : ", obj)
      var vblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      vfd.append("userviewedprofile   ", vblob)
      httpuserprofile.post("/userprofile/userviewedprofile", vfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log("successfully viwewed : ", response)
      }).catch((e) => {
        console.log(e)
      })
    },
    getUserProfileVerificationData() {
      httpuserprofile.get('/userprofile/aadharVerificationStatus?profileId='+this.profileId)
      .then((response) => {
        console.log("user verification data : ", response.data)
        this.loadingverificationData = false;
        this.userVerificationData = response.data;
      }).catch((e) => {
        this.loadingverificationData = false;
        console.log(e.response)
      })
    },
    /////////////// if selected user ///////////////////////////
    //report user functionality
    getReportprofile(){
      this.reportprofilemodal = true;
      let item = {}
      item.checkobj = "hiphiphurray"
      item.profileId  = this.profileId;
      item.currentUserEmail = this.currentUserEmail
      this.reportprofileobject = item;  
    }, 
    //close report user modal
    closereportprofileModal(){
      this.reportprofilemodal = false;
    },
    followUser(){   
      if(this.currentRoute != 'selectedloginviewuserprofile'){
      this.disablefollowBtn = true;   
      console.log("followuser btn clicked", this.loginuserprofileid, this.profileId)    
      httpuserprofile
        .post("/userprofile/saveFollowing?profileId="+this.loginuserprofileid+"&followingId="+this.profileId)
        .then(response => {
          if(response.data){            
            this.followingTest ="UnFollow";
            this.disablefollowBtn = false;
            this.followersCount = this.followersCount + 1;
            //this.getUserByID(this.selectedUser);
          }                   
        }).catch((e) => {
          console.log(e)
          this.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        }) 
      }else{
        this.navToSignInWithSelectedUser()
      }      
    },
    getInTouch() {
      if(this.currentRoute == 'selectedloginviewuserprofile'){
        this.navToSignInWithSelectedUser()
      }
    },
    navToSignInWithSelectedUser(){
      this.$session.set("selectedUserAliasname", this.getuseraliasname)
      this.$session.set("selectedJodDetailsFromLogin", true)
      router.push({
        name : 'signin'
      })
    },
    UnfollowUser(){  
      this.disablefollowBtn = true;   
      console.log("unfollow btn clicked") 
      httpuserprofile.delete("/userprofile/unfollow?profileId="+this.loginuserprofileid+"&followingId="+this.profileId)
        .then(response => {
          if(response.data){
            console.log(response)
            this.followingTest= 'Follow'
            this.disablefollowBtn = false;
            this.followersCount = this.followersCount - 1;
            //this.getUserByID(this.selectedUser);
          }          
        }).catch((e) => {
          console.log(e)
          this.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        })         
    },
    // handle data tabs
    profileDetails() {
      console.log("profile details");
      this.showprofiledetails = true;
      this.showvideoprofile = false;
      this.showvidoes = false;
    },
    videoProfile() {
      this.showprofiledetails = false;
      this.showvideoprofile = true;
      this.showvidoes = false;
    },
    myVideos() {
      this.showvidoes = true;
      this.showvideoprofile = false;
      this.showprofiledetails = false;
    },
  },
  mounted() {
    //set page scroll
    window.scrollTo(0, 0)
    //comment
    this.getuserid = sessionUtils.getUserId();
    this.getuseraliasname = sessionUtils.getUserAliasName()
    //set selected user id
    this.currentRoute = this.$route.name;
    if(this.currentRoute == 'wn' || this.currentRoute == 'selectedloginviewuserprofile'){
      this.getuseraliasname = this.$route.params.id;
      this.fetchdata();
    }else{
      this.pageloader = false;
    }
    document.body.style.zoom = "100%";
    bus.$on('refershDataWhenInUserProfilePage', data => {
      if(data == this.getuseraliasname){
        this.pageloader = true;
        this.resetData()
        this.fetchdata();
      }
    })
    // update profile strength info after uploaded profile/resume video
    bus.$on("successfullysavedprofileresumevideo", data => {
      if(data == 'PROFILE'){
        setTimeout(() => {
          this.profilePercentage +=15;
          this.getprofileStrengthLabel()
        }, 1000)
      }else if(data == 'RESUME'){
        setTimeout(() => {
          this.profilePercentage +=15;
          this.getprofileStrengthLabel()
        }, 1000)
      }
    })
    // update profile strength info after deleted profile/resume video
    bus.$on('reduceprofilePercentageAfterdeleteProfileResumeVideo', data => {
      if(data){
        this.profilePercentage -=15;
        this.getprofileStrengthLabel()
        if(data == 'PROFILE'){
          this.profileVideoId = null;
          this.profileVideoDetails = null;
        }else if(data == 'RESUME'){
          this.resumeVideoId = null;
          this.resumeVideoDetails = null;
        }
      }
    });
    // update profile/resume video info after uploaded profile/resume video
    bus.$on('updateProfileResumevideodataInWelcome', data => {
      if(data && data.type == 'PROFILE'){
        this.profileVideoId = data.id;
        this.profileVideoDetails = data.videoDetails;
      }else if(data && data.type == 'RESUME'){
        this.resumeVideoId = data.id;
        this.resumeVideoDetails = data.videoDetails;
      }
    });
    bus.$on('updatedOpenToWorkData', data => {
      if(data) {
        this.fetchOpenToWorkInformation()
      }
    })
  },
  beforeDestroy() {
    console.log("check destroy")
    bus.$off("successfullysavedprofileresumevideo")
    bus.$off("reduceprofilePercentageAfterdeleteProfileResumeVideo")
    bus.$off("updateProfileResumevideodataInWelcome")
    bus.$off('updatedOpenToWorkData')
    bus.$off('refershDataWhenInUserProfilePage')
    document.title = "Worknotion | Collaboration Network and Job search"
    document.description = "Worknotion is a professional networking platform that allows users to build community, grow their network, get freelance projects, search and apply for jobs online for free."
    var video = document.getElementById("vid")
    if(video !== null && video !== undefined) {
      video.pause()
    }
  },
  destroyed() {
  }
};
</script>
<style scoped>
@import '../css/croppie.css';
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  padding: 2px;
  /* margin-top: -3px; */
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.edit {
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 50%;
	/* padding-top: 7px;
	padding-right: 7px; */
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
	/* display: none; */
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.nav-tabs {
  border-bottom: none !important;
}
.backgroundgradient{
  background-color: #2f86ea;
  height: 350px;
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 20px;
}
.copylink{
  height: 20px !important;
}
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
/* #follower:hover{
  color: #0078ff;
  cursor: pointer;
  text-decoration: underline;
} */
.follower:hover{
  color: #0078ff !important;
  cursor: pointer;
  text-decoration: underline;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}

.modal-body{
  background-color: #000000
}
.modal{
  background-color: rgba(31,31,31,.89);
}
.navtoPage {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  padding-left : 5px;
  padding-top: 2px;
  /* color: #0078FF !important; */
  /* border: 1px solid #0078FF; */
  /* border-radius: 16px;
  padding-left: 5px !important; */
}
.navtoPage::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.navtoPage:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.profileStrengthpop.dropdown-position-bottom {
  left: 0px !important;
  top: 45px !important;
  width: 300px !important;
  padding: 20px 0px 0px 20px !important;
}

.profileStrengthpop.vue-popover.dropdown-position-bottom:before {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  top: -6px;
  /* right: 50px; */
  left: 190px !important;
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
.menuicon {
  cursor: pointer;
}
.moreactionsmenu {
  width: 25px;
  padding: 3px;
  border: 1px solid white;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.welcomemenu.dropdown-position-bottom {
  /* left : 320px  !important; */
  left: 48% !important;
  width: 290px !important;
  top: 30px !important;
  font-size: 14px;
  padding: 0px 0px 0px 00px !important;
}
.welcomemenu.dropdown-position-bottom::before{
  /* left: 235px !important; */
  left: 80% !important;
}
ul li::marker {
  color: #1f1f1f;
  opacity: 0.8;
  font-size: 1.5em;
}

.line {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.line-opacity-4 {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.04;
}

.ul-list {
  list-style-type: none;
}
.myvideosection {
  overflow: auto;
  white-space: nowrap;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.myvideosection span{
  display: inline-block;
  text-align: center;
  /* padding: 14px; */
  text-decoration: none;
}
.myvideosection::-webkit-scrollbar {
  display: none;
}
.button {
  color: #1f1f1f !important;
}
.closebtnmouseover1{
  border: 1px solid white;
  padding: 0 3px 0 3px;
}
.closebtnmouseover1:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn:hover {
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
  /* font-weight: bold; */
}
svg {
  width: 50px;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.percentageblock {
  padding-right: 0px !important;
  padding-left: 8px !important;
}
.percentage,
.sub {
  display: flex;

}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.nameblock {
  padding-left: 0 !important;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.sub {
  font-size: 25px;
}
.count {
  margin-left: 17%;
}
.profileimgad {
	background: url('../assets/loading_gif.gif') no-repeat;
  background-position: center;
  background-size: 30px 30px;
}
.profileImgSize{
  height: 100px;
}
#profImage1{
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.fixed{
  position: fixed;
  height: 95vh;
  overflow-y: auto;
  padding-bottom: 50px !important;
}
.fixed::-webkit-scrollbar {
  display: none;
}
@media only screen and (max-width: 600px) {
  .fontsize32{
    font-size: 20px !important;
  }
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .profile-border{
    padding: 0px !important;
  }
  .welcomename {
    margin-top: -7px !important;
    /* font-size: 25px !important; */
  }
  .count {
    /* margin-left: 18%; */
    margin-left: 0 !important;
  }
  .fontsize22{
    font-size: 18px !important;
  }
  .profilestrength {
    margin-left: 0px !important;
  }
  .noheightforsmall{
    height: 0px;
  }
}
@media screen and (max-width: 1440px ) and (min-width: 1024px) {
  .welcomemenu.dropdown-position-bottom {
    left : 43%  !important;
  }
}
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .welcomemenu.dropdown-position-bottom {
    left : 24%  !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 600px) {
  .welcomemenu.dropdown-position-bottom {
    left : 42%  !important;
  }
  .noheightforsmall{
    height: 0px;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (max-width: 600px) and (min-width: 539px) {
  .welcomemenu.dropdown-position-bottom {
    left : 20%  !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 50% !important;
  }
}
@media screen and (max-width: 539px) and (min-width: 400px) {
  .welcomemenu.dropdown-position-bottom {
    left : -40px  !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 45% !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 350px) {
  .welcomemenu.dropdown-position-bottom {
    left : -65px  !important;
  }
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 50% !important;
  }
}
@media screen and (max-width: 350px) and (min-width: 300px) {
  .profileStrengthpop.vue-popover.dropdown-position-bottom:before {
    left: 45% !important;
  }
  .sub {
    font-size: 20px !important;
    margin-top: 9px !important;
  }
  .welcomemenu.dropdown-position-bottom {
    left : -30%  !important;
    width: 270px !important;
  }
}
@media screen and (max-width: 300px) {
  .welcomemenu.dropdown-position-bottom {
    left : -30%  !important;
  }
}
</style>